
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5e020347e80e10b43816f6cf00220ed8.jpg"
          alt="Baseball Training Biomechanics"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 px-5 lg:px-12 max-w-7xl mx-auto w-full pt-20">
        <div className="max-w-3xl">
          <div className="mb-6">
            <h1 className="text-3xl sm:text-5xl lg:text-7xl font-black text-white leading-tight mb-4">
              DATA-DRIVEN<br />BASEBALL PERFORMANCE
            </h1>
            <p className="text-base sm:text-xl lg:text-2xl text-gray-100 font-light leading-relaxed">
              Biomechanics-focused training powered by ArmCare, Rapsodo, UpLift AI, and NewtForce technology
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-4 bg-teal-500 text-white text-sm font-bold rounded-lg hover:bg-teal-600 transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              Book On-Site Assessment
            </button>
            <button
              onClick={() => scrollToSection('technology')}
              className="px-6 py-4 bg-transparent border-2 border-white text-white text-sm font-bold rounded-lg hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              View Technology
            </button>
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/30">
            <i className="ri-map-pin-line text-teal-400"></i>
            <span className="text-sm text-white font-medium whitespace-nowrap">Corsicana, TX | 50min from Dallas</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}
